import { PluralForms } from '../types';

/** Russian needs three forms: 1 проект, 2 проекта, 5 проектов. */
export const plural = (count: number, forms: PluralForms): string => {
  const abs = Math.abs(count);
  const mod10 = abs % 10;
  const mod100 = abs % 100;

  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1];
  return forms[2];
};

export const withPlural = (count: number, forms: PluralForms): string =>
  `${count} ${plural(count, forms)}`;
